"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 1 };
const vue_map_sdk_1 = require("@xenodrive/vue-map-sdk");
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BssMapAddress',
    props: {
        lnglat: {}
    },
    setup(__props) {
        const props = __props;
        const loading = (0, vue_3.ref)(true);
        const latlng = (0, vue_3.computed)(() => { var _a; return (_a = (0, vue_map_sdk_1.parseLngLat)(props.lnglat).toLatLngArray()) === null || _a === void 0 ? void 0 : _a.slice(0, 2).join(','); });
        const map_api_url = (0, vue_3.inject)('map_api_url');
        const messages = (0, vue_3.inject)('messages');
        const address = (0, vue_3.ref)('');
        const ajax = window._ajax;
        const ZDC = window.ZDC;
        (0, vue_3.onMounted)(() => {
            (0, vue_3.watch)(latlng, () => __awaiter(this, void 0, void 0, function* () {
                loading.value = true;
                address.value = '---';
                const apiName = 'location';
                const params = {
                    api: apiName,
                    latlon: latlng.value,
                    addrlevel: 'azc',
                    limit: 1,
                };
                ajax.background(map_api_url, params, function (result) {
                    ZDC.Search.getByZmaps(apiName, result.params, function (status, res) {
                        var _a, _b;
                        if (status.code === 200 && res.length > 0) {
                            const rec = res[0];
                            address.value = (_b = (_a = rec === null || rec === void 0 ? void 0 : rec.address) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : messages.v_infobox.address_failed;
                        }
                    });
                }, function (xhr, status, errorThrown) {
                    address.value = messages.v_infobox.address_failed;
                });
                loading.value = false;
            }), { immediate: true });
        });
        return (_ctx, _cache) => {
            return (loading.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_1, [
                    (0, vue_2.renderSlot)(_ctx.$slots, "default")
                ]))
                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_2, (0, vue_2.toDisplayString)(address.value), 1));
        };
    }
});
